import { useQuery } from '@tanstack/react-query';
import { getFormDefinition, getFormSubmission, getFormDefinitionForSubmission, formSubmissionResults, getFormKeysByFormId } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useFormDefinitionQuery = (formId?: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'form', formId, 'definition' ],
    queryFn: async () => {
      if (!formId) return null;

      const response = await getFormDefinition(formId);

      if ('error' in response) {
        throw new Error(response.error);
      }

      return response.definition;
    },
    ...opts
  });
};


export const useFormDefinitionForSubmissionQuery = (submissionId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'form-submission', submissionId, 'definition' ],
    queryFn: async () => {
      const response = await getFormDefinitionForSubmission(submissionId);

      if ('error' in response) {
        throw new Error(response.error);
      }

      return response.form;
    },
    ...opts
  });
};

export const useFormSubmissionQuery = (submissionId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'form-submission', submissionId ],
    queryFn: async () => {
      const response = await getFormSubmission(submissionId);
      // formSubmissionResults

      if ('error' in response) {
        throw new Error(response.error);
      }

      return response.submission;
    },
    ...opts,
  });
};


export const useFormSubmissionResultsQuery = (submissionId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'form-submission', submissionId, 'results' ],
    queryFn: async () => {
      const response = await formSubmissionResults({ submission_id: submissionId });

      return response;
    },
    ...opts,
  });
};


export const useFormKeysQuery = () => {
  return useQuery({
    queryKey: [ 'forms', 'keys' ],
    queryFn: getFormKeysByFormId,
    select: (data) => data.data,
  });
};
